import { createSelector } from 'reselect';

const selectMedia = (state) => state.media;

export const selectRemoteStreams = createSelector(
  [selectMedia],
  (media) => media.remoteStreams
);


export const selectAdmittedParticipants = createSelector(
  (state) => state.room.currentRoom?.participants || [],
  // A participant remains fully admitted while sharing a screen.  Filtering
  // out `presenting` made the presenter disappear from the camera rail, gave
  // the screen an "Unknown" label and repeatedly reset the spotlight.
  (participants) =>
    participants.filter((participant) =>
      ['admitted', 'presenting'].includes(participant.status)
    )
);
